import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, setCategoriesAction } from '../../reducers/actions';
import { CategoryService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_CATEGORIES),
    switchMap(action =>
      CategoryService.getBySiteId(action.siteId, store).pipe(
        map(data => setCategoriesAction(data)),
        catchError(retryAuthentication(action$, 'epics/categories/getCategories'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/categories/getCategories.js